import { BlocksResultProps } from '@grapesjs/react';

import { Box, Divider } from '@mui/material';
import { AgText } from 'src/components/ui';
import { GLOBAL_APP_BAR_HEIGHT } from 'src/modules/pageFrame/SiteHeader';

export type CustomBlockManagerProps = Pick<BlocksResultProps, 'mapCategoryBlocks' | 'dragStart' | 'dragStop'>;

export default function CustomBlockManager({ mapCategoryBlocks, dragStart, dragStop }: CustomBlockManagerProps) {
  return (
    <Box
      className="gjs-custom-block-manager"
      sx={{ overflow: 'auto', height: `calc(100vh - ${GLOBAL_APP_BAR_HEIGHT}px)` }}
    >
      {Array.from(mapCategoryBlocks).map(([category, blocks]) => (
        <div key={category}>
          <Divider />
          <Box sx={{ p: 1 }}>
            <AgText size="h6">{category}</AgText>
          </Box>
          <Divider />
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, p: 2 }}>
            {blocks.map((block) => (
              <Box
                key={block.getId()}
                draggable
                onDragStart={(ev) => dragStart(block, ev.nativeEvent)}
                onDragEnd={() => dragStop(false)}
                sx={{
                  backgroundColor: '#E0E0E0',
                  borderRadius: 6,
                  cursor: 'grab',
                  px: 1,
                  '&:hover': { backgroundColor: '#D0D0D0' },
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <div className="text-sm text-center w-full" title={block.getLabel()}>
                  {block.getLabel()}
                </div>
              </Box>
            ))}
          </Box>
        </div>
      ))}
    </Box>
  );
}
